import React from "react";
import { BackgroundProps } from "../../../../@types/background";
import { ModalType, useModal } from "../../../../Context/ModalContext";
import { useAppDispatch, useAppSelector } from "../../../../hook/redux";


/**
 * Generates and returns the appropriate background style object based on the background properties provided.
 *
 * @param {BackgroundProps} background - An object containing the properties that define the background style.
 * Properties may include `type` (e.g., "image", "color", "gradient"), `value` (URL, color code, or gradient), and
 *   optional `backgroundPosition`.
 * @return {object} A style object representing the background settings. If no valid background type is provided, an
 *   empty object is returned.
 */
export function getBackgroundStyle(background: BackgroundProps) {
  if (!background) return {};

  switch (background.type) {
    case "image" :
    case "base":
      return {
        backgroundImage: `url(${background.value})`,
        backgroundPosition: background.backgroundPosition || "center",
        backgroundSize: "contain",
      };
    case "color":
    case "gradient":
      return {
        background: background.value,
      };
    default:
      return {};
  }
}

function LayoutSelector( { canvas } ) {
  const { selectedBackground, selectedLayout, loadInPageMultimgEditor } = useAppSelector( ( state ) => state.editor );
  const orientation = useAppSelector( ( state ) => state.editor.loadInPageMultimgEditor.orient );
  const backgroundWithOrientation = selectedBackground[ orientation ];
  const dispatch = useAppDispatch();

  const { toggleShow } = useModal();

  return (
    <>
      {backgroundWithOrientation && backgroundWithOrientation.value &&
        <a
          className="toolbar-button d-flex p-1 justify-content-center align-items-center"
          data-test={"layout-mobile"}
          onClick={ () => {
            dispatch({
              type: "editor/updateCurrentDataFabricArray",
              payload: {
                layoutId: selectedLayout,
                fabricElements: JSON.stringify(canvas.toJSON()),
              }
            });
            toggleShow( true, null, ModalType.layout );
          } }
          >
          <img style={{...getBackgroundStyle(backgroundWithOrientation), maxWidth: "100%", maxHeight: "100%"}}
               src={`${process.env.PREFIX_URL}/v2017/html2canvas/proximg.php?img=/assets/v2017/layout-carte-prevu/${loadInPageMultimgEditor.orient}/${selectedLayout}_small.gif`}
               alt="layout" />
        </a>
      }
    </>
  );
}

export default LayoutSelector;